import { useQuery } from 'react-query';
import { getClientData } from '../api/clientData';

export const useClientData = (commercialLabel: string, loanNumber: number, enabled = true) => {
  return useQuery(
    ['client-data', commercialLabel, loanNumber],
    () => getClientData(commercialLabel, loanNumber),
    { enabled }
  );
};
